import React, { useEffect, useState } from "react";
import "./sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import dashboardIcon from "../../assets/Chart.png";
import register1 from "../../assets/users.png";
import bondM1 from "../../assets/cil_money.png";
import investM1 from "../../assets/bar-chart-2.png";
import cms1 from "../../assets/fa6-regular_user.png";
import report1 from "../../assets/innerContainer.png";
import profie1 from "../../assets/userM1.png";
import dashchart from "../../assets/Chartadmin.png";
import regchar2 from "../../assets/bar-chart-2 (1).png";
import bondchart2 from "../../assets/cil_money (1).png";
import investchar2 from "../../assets/innerContainer (1).png";
import { useSelector } from "react-redux";

// List of menu items with support for multiple paths
const menuItems = [
  {
    label: "Dashboard",
    paths: ["/dashboard"],
    icon2: dashboardIcon,
    iconClass: dashchart,
    title: "dashboard",
  },
  {
    label: "Registration Management",
    paths: ["/registration/investor", "/registration/wealth-partner"], // Multiple paths
    iconClass: register1,
    icon2: regchar2,
    title: "registration",
  },
  {
    label: "Investment Management",
    paths: [
      "/investment-management/investor",
      "/investment-management/wealth-partner",
    ], // Multiple paths
    iconClass: investM1,
    icon2: investchar2,
    title: "investment",
  },
  {
    label: "Bond Management",
    paths: ["/bond"],
    iconClass: bondM1,
    icon2: bondchart2,
    title: "bond",
  },
  {
    label: "CMS",
    paths: ["/cms/investor"],
    iconClass: cms1,
    icon2: bondchart2,
    title: "cms",
  },
  {
    label: "Report",
    paths: ["/report"],
    iconClass: report1,
    icon2: bondchart2,
    title: "report",
  },
  {
    label: "User Management",
    paths: ["/user"],
    iconClass: profie1,
    icon2: bondchart2,
    title: "user",
  },
  {
    label: "Relationship Manager",
    paths: ["/relationship-manager"],
    iconClass: profie1,
    icon2: bondchart2,
    title: "user",
  },
  {
    label: "Sell Request",
    paths: ["/sell-request"],
    iconClass: bondM1,
    icon2: bondchart2,
    title: "user",
  },
  {
    label: "Invite Partner",
    paths: ["/invite-partner"],
    iconClass: bondM1,
    icon2: bondchart2,
    title: "user",
  },
  {
    label: "Manage Client",
    paths: ["/manage-client/client"],
    iconClass: bondM1,
    icon2: bondchart2,
    title: "user",
  },
  {
    label: "Manage Resources",
    paths: ["/manage-resource/public"],
    iconClass: bondM1,
    icon2: bondchart2,
    title: "user",
  },
];

function Sidebar() {
  const [activeItem, setActiveItem] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { userPermissionData } = useSelector((state) => state.userPermission);

  useEffect(() => {
    if (!userPermissionData) return; // Guard clause to prevent null access

    // Get available menu items based on permissions
    const availableMenuItems = menuItems.filter((item) => {
      try {
        return hasPermission(item);
      } catch (error) {
        return false; // Safely handle any permission check errors
      }
    });

    // Set active item based on current route or first available item
    const currentItem = menuItems.find((item) =>
      item.paths.some((path) => location.pathname.startsWith(path))
    );

    if (currentItem && hasPermission(currentItem)) {
      setActiveItem(currentItem.label);
    } else if (availableMenuItems.length > 0) {
      const firstAvailableItem = availableMenuItems[0];
      setActiveItem(firstAvailableItem.label);

      // Only redirect if we're at dashboard and don't have access to it
      if (location.pathname === "/dashboard" && !hasPermission(menuItems[0])) {
        navigate(firstAvailableItem.paths[0]);
      }
    }
  }, [location.pathname, userPermissionData]);

  const handleItemClick = (label, path) => {
    
    console.log("label",label)
    setActiveItem(label);
    localStorage.setItem("bondManagementPage", 1);
    navigate(path);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev); // Toggle the sidebar open/closed
  };

  const hasPermission = (item) => {
    if (!userPermissionData || !item?.title) return false;

    const permission = userPermissionData[item.title];
    if (!permission) return false;

    if (item.title === "cms") {
      return permission.manage === true;
    }
    return permission.view === true;
  };

  console.log("userPermissionData", userPermissionData);

  console.log("activeItem",activeItem)

  return (
    <div className="sidebar-container">
      {/* Hamburger Icon (Mobile Only) */}
      <div className="hamburger-icon" onClick={toggleSidebar}>
        <span className="hamburger">
          {" "}
          {isSidebarOpen ? "✕" : String.fromCharCode(9776)}{" "}
        </span>
      </div>

      {/* Sidebar */}
      <nav className={`sidebar-wrapper sidebar ${isSidebarOpen ? "open" : ""}`}>
        <ul>
          {userPermissionData &&
            menuItems
              ?.filter((item) => hasPermission(item))
              .map((item) => (
                <li
                  key={item.label}
                  className={`flex ${
                    activeItem === item.label ? "bg-[#035C98] text-white" : ""
                  }`}
                  onClick={() => handleItemClick(item.label, item.paths[0])}
                >
                  <div className="flex justify-center items-center px-4 cursor-pointer">
                    <img
                      className="w-5 h-5"
                      src={
                        activeItem === item.label ? item.icon2 : item.iconClass
                      }
                      alt={item.label}
                    />
                    <p className="ml-4">{item.label}</p>
                  </div>
                </li>
              ))}
        </ul>
      </nav>

      {/* Add overlay for mobile */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
    </div>
  );
}

export default Sidebar;
